// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/admin.scss
// module id = 17
// module chunks = 2